import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import './global-components'
import './vendor-components'
import App from './App.vue'
import router from './router'
import store from './store'
// Global Filters
import toLocaleString from './filters/toLocaleString'
// Services
import repositories from './repositories/RepositoryFactory'
import customerGroup from './services/customerGroup'
import dialog from './services/dialog'
import help from './services/help'
import queryNotification from './services/queryNotification'
import windowResize from './services/windowResize'
import token from './services/token'
import { fetchCurrentStatus, serviceStatus } from './services/serviceStatus'
// filters
import { formatNumeric } from './filters/number'

import DialogUncaughtError from './components/DialogUncaughtError.vue'

// Global Styles
import './assets/variables.scss'
import './assets/style.scss'

// Vuex Mutations and Actions
import { SET_SERVICE_STATUS } from './const/mutation-types'
import { LOAD_BASIC_MASTERS } from './const/action-types'

Vue.config.productionTip = false

// コンポーネント共通で扱うFilter登録
Vue.filter('localeString', toLocaleString)
Vue.filter('formatNumeric', formatNumeric)

// Error Handling
window.addEventListener('error', err => {
  // eslint-disable-next-line no-console
  console.error('Error caught in window:', err)
  let error
  if (err.error) {
    error = err.error
  }

  dialog.open(DialogUncaughtError, { err: error })
})

Vue.config.errorHandler = (err, vm, info) => {
  // eslint-disable-next-line no-console
  console.error('Error caught in Vue (err):', err, vm, info)
  // eslint-disable-next-line no-console
  console.error('Error caught in Vue (vm):', vm)
  // eslint-disable-next-line no-console
  console.error('Error caught in Vue (info):', info)

  dialog.open(DialogUncaughtError, { err, vm, info })
}

if (process.env.VUE_APP_SENTRY_DSN) {
  // https://jp.vuejs.org/v2/guide/deployment.html#%E3%83%A9%E3%83%B3%E3%82%BF%E3%82%A4%E3%83%A0%E3%82%A8%E3%83%A9%E3%83%BC%E3%81%AE%E8%BF%BD%E8%B7%A1
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  })
}

async function loadVue() {
  try {
    const status = await fetchCurrentStatus()
    store.commit(SET_SERVICE_STATUS, status)
  } catch (error) {
    alert('サービス稼働状況が取得できませんでした。')
    // eslint-disable-next-line no-console
    console.error('サービス稼働状況が取得できませんでした。', error)
    return
  }

  const ssoClient = new window.C3LabSsoClient(process.env.VUE_APP_AUTH_URL)
  await ssoClient.init()
  let savedToken = await ssoClient.getToken()

  if (!savedToken.accessToken) {
    savedToken = await ssoClient.signinWithPopup()
  }

  if (!savedToken.accessToken) {
    alert('認証に失敗しました')
    return
  }

  // 他コンポーネントでも参照するためWindowに登録しています
  // TODO ちゃんとVueに登録する
  window.ssoClient = ssoClient

  try {
    await store.dispatch(LOAD_BASIC_MASTERS, {
      companyCode: savedToken.companyCode,
      loginId: savedToken.loginId,
    })
  } catch (error) {
    if (
      error.response &&
      error.response.status === 400 &&
      error.response.config.url === savedToken.refreshUrl
    ) {
      // トークンリフレッシュの失敗はもうどうしようもないので未認証状態として続行
    } else {
      alert('マスタのロードに失敗しました。')
    }
  }

  new Vue({
    router,
    store,
    repositories,
    customerGroup,
    dialog,
    queryNotification,
    help,
    windowResize,
    token,
    render: h => h(App),
  }).$mount('#app')

  serviceStatus.subscribe(
    status => {
      store.commit(SET_SERVICE_STATUS, status)
    },
    error => {
      alert('サービス稼働状況が取得できませんでした。')
      // eslint-disable-next-line no-console
      console.error('サービス稼働状況が取得できませんでした。', error)
    },
  )
}

loadVue()
